import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./LangSwitcher.css";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  // Normalized two-letter language code (ex:  "en" from "en-US")
  const currentLang = (i18n.language || "en").split("-")[0].toLowerCase();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (language) => {
    localStorage.setItem("currentLang", language.toLowerCase());
    i18n.changeLanguage(language);
    setIsOpen(false);
  };

  // Ensure the app language is in sync with localStorage (or browser settings on first visit)
  useEffect(() => {
    const storedLang = localStorage.getItem("currentLang");

    if (storedLang) {
      // normalise the value (ex:  "EN" -> "en")
      const language = storedLang.toLowerCase();
      if (i18n.language !== language) {
        i18n.changeLanguage(language);
      }
    } else {
      // First visit: try browser language, else default to "en"
      const browserLang = (navigator.language || "en").split("-")[0].toLowerCase();
      const initialLang = ["en", "fr"].includes(browserLang) ? browserLang : "en";
      localStorage.setItem("currentLang", initialLang);
      i18n.changeLanguage(initialLang);
    }
  }, []);

  return (
    <header
      className={`main-header ${
        isOpen ? "show-options show-shadow anim-options" : ""
      }`}
    >
      <div className={`switch ${isOpen ? "show-shadow" : ""}`}>
        <div
          className={`lang-btn btn-outline-sm current`}
          onClick={(e) => {
            e.stopPropagation();
            // changeLanguage("fr");
            setIsOpen(!isOpen);
          }}
        >
          <img src={`/assets/images/flags/${currentLang}.png`} alt={currentLang} />
          <span className="">{currentLang}</span>
        </div>
        <div className={`options ${isOpen ? "anim-options pr--20" : ""}`}>
          <ul className="options-list">
            <li
              onClick={(e) => {
                e.stopPropagation();
                changeLanguage("en");
              }}
            >
              <img src="/assets/images/flags/en.png" alt="US Flag" />
              <span>English</span>
            </li>
            <li
              onClick={(e) => {
                e.stopPropagation();
                changeLanguage("fr");
              }}
            >
              <img src="/assets/images/flags/fr.png" alt="French Flag" />
              <span>Francais</span>
            </li>
          </ul>
          <div id="trans-circle">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
              <g fill="none" fillRule="evenodd">
                <circle id="bg" cx="60" cy="60" r="60" fill="#FFFFFF" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </header>
  );
}

export default LanguageSwitcher;
